export default {
    SELECT_DOCUMENT: "Выберите документ для просмотра задач",
    NO_DOCUMENT_TASKS: "В документе нет задач"
};
